import { atom, type PrimitiveAtom } from "jotai";
import type { AuthCredentials } from "../../interface/auth_types";

export const remoteClientAuthenticatedCredentialsAtom =
  atom<AuthCredentials | null>(null) as PrimitiveAtom<AuthCredentials | null>;
